import { connect } from 'react-redux'
import { compose, withHandlers, withState, lifecycle } from 'recompose'
import { getHasActiveVehicleStatus } from 'selectors'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'
import { showNewShopTiresModal } from '../../NewShopTiresModal/actions'

const withAddToQuoteHandlers = withHandlers({
  // onClick comes from withPromotionLightBox or withAddToQuote
  handleClick: ({
    onClick,
    hasActiveVehicle,
    setPendingAddToQuote,
    noTireSizeOnClick,
    preventNavigation = false,
    showNewShopTiresModal
  }) => () => {
    if (hasActiveVehicle) {
      noTireSizeOnClick ?
        noTireSizeOnClick(null, null, null, {
          preventNavigation,
          tiresSelectExtraCallbacks: [() => setPendingAddToQuote(true)]
        }) :
        onClick()
    } else {
      showNewShopTiresModal({
        isOnlyVehicle: true,
        ymmeName: YMME_NAME,
        withShowConfirmTireSizeModal: true,
        source: GENERAL_SOURCE
      })
    }
  }
})

const withPendingAddToQuote = lifecycle({
  componentDidUpdate(prevProps) {
    const { disabled, isLoading, setPendingAddToQuote, pendingAddToQuote, onClick } = this.props
    if (prevProps.isLoading && !isLoading && pendingAddToQuote) {
      if (!disabled) {
        onClick()
      }
      setPendingAddToQuote(false)
    }
  }
})

const mapStateToProps = state => ({
  hasActiveVehicle: getHasActiveVehicleStatus(state),
  isLoading: state.app.isLoading || state.app.isFetching
})

export default compose(
  withState('pendingAddToQuote', 'setPendingAddToQuote', false),
  connect(mapStateToProps, { showNewShopTiresModal }),
  withPendingAddToQuote,
  withAddToQuoteHandlers
)
